module.exports = __webpack_public_path__ + "static/media/rank.fa4d8363.png";